import React from 'react'
import SmallListDetail from './SmallListDetail'
import { Icon } from "n2-styles"; 

const CsrTeamMembersIndex = ({ data = [] }) => {
  const rows = data.map((job) => {
    return (
      <a key={job.index} className="list-group-item u-hover--raised" href={job.href}>
        <div className="d-flex w-100 align-items-center cursor-pointer row">

          <div className="ml-2 d-flex flex-column col-5 col-sm-3">
            {job.area_director_name}
            <SmallListDetail content={job.publication_name} />
            <SmallListDetail content={job.territory_name} />
          </div>

          <div className="d-flex flex-column col-3 col-sm-2">
            <SmallListDetail content={job.deadline_day} />
            <SmallListDetail content={job.issue_date} />
          </div>

          <div className="d-flex flex-column col u-wrap d-none d-sm-block">
            <SmallListDetail content={job.titleized_status} />
          </div>

          <div className="d-none d-sm-flex flex-column col u-wrap">
            <SmallListDetail content={job.rounds_of_revisions} />
            <SmallListDetail content={job.annotations_count} />
            <SmallListDetail content={job.overage_fees} />
          </div>

          <div className="d-none d-sm-flex flex-column col u-wrap">
            <SmallListDetail content={job.time_in_waiting} />
            <SmallListDetail content={job.time_in_revisions} />
          </div>

          <div className="d-flex flex-column col-1 align-items-center ml-auto">
            <Icon icon="keyboard_arrow_right" label="See more" />
          </div>
        </div>
      </a>
    )
  })

  return (
    <ul className="list-group list-group-flush mb-6">
      {rows}
    </ul>
  )
}

export default CsrTeamMembersIndex
